import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiDirectAnnouncement, ApiDirectAnnouncementPreview, ApiDirectAnnouncementPrice } from '@app/packages/api/v2/types/entities'
import type { ApiDataResponse } from '@app/packages/api/v2/types/misc'
import type {
  ApiDirectAnnouncementPreviewRequest,
  DirectAnnouncementCalculateRequest,
  DirectAnnouncementRequest,
  PutDirectAnnouncementsAcceptRequest,
} from '@app/packages/api/v2/types/params'

export const getDirectAnnouncementsById = (direct_announcement_id: string) =>
  createApiAction('getDirectAnnouncementsById', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncement>>({ method: 'GET', endpoint: urlEscaped`/api/v2/direct_announcements/${direct_announcement_id}` })
  )

export const postDirectAnnouncements = (request: DirectAnnouncementRequest) =>
  createApiAction('postDirectAnnouncements', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncement>>({ method: 'POST', endpoint: '/api/v2/direct_announcements', body: JSON.stringify(request) })
  )

export const putDirectAnnouncementsAccept = (direct_announcement_id: string, request: PutDirectAnnouncementsAcceptRequest) =>
  createApiAction('putDirectAnnouncementsAccept', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncement>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/direct_announcements/${direct_announcement_id}/accept`,
      body: JSON.stringify(request),
    })
  )

export const putDirectAnnouncementsCancel = (direct_announcement_id: string) =>
  createApiAction('putDirectAnnouncementsCancel', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncement>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/direct_announcements/${direct_announcement_id}/cancel`,
    })
  )

export const putDirectAnnouncementsDecline = (direct_announcement_id: string, reason?: string) =>
  createApiAction('putDirectAnnouncementsDecline', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncement>>({
      method: 'PUT',
      endpoint: urlEscaped`/api/v2/direct_announcements/${direct_announcement_id}/decline`,
      body: reason ? JSON.stringify({ reason }) : undefined,
    })
  )

export const postDirectAnnouncementsCalculate = (request: DirectAnnouncementCalculateRequest) =>
  createApiAction('postDirectAnnouncementsCalculate', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncementPrice>>({
      method: 'POST',
      endpoint: '/api/v2/direct_announcements/calculate',
      body: JSON.stringify(request),
    })
  )

export const postDirectAnnouncementsPreview = (request: ApiDirectAnnouncementPreviewRequest) =>
  createApiAction('postDirectAnnouncementsPreview', dispatch =>
    dispatch<ApiDataResponse<ApiDirectAnnouncementPreview>>({
      method: 'POST',
      endpoint: '/api/v2/direct_announcements/preview',
      body: JSON.stringify(request),
    })
  )
